// LM: botão "Ir para o checkout" (blocks/lm-ir-checkout.liquid)
if (!customElements.get('lm-ir-checkout')) {
  (function () {
    var PARAM = 'promocode';
    // Yampi monta o link do checkout com ymp_getUrlWithUtms: acrescenta o cupom quando o pedido saiu deste botão
    function comCupom(url) {
      var c = window.lmCupomCheckout;
      if (!c || !url) return url;
      try { var u = new URL(url, location.href); u.searchParams.set(PARAM, c); return u.toString(); } catch (e) { return url; }
    }
    function embrulhar() {
      if (typeof window.ymp_getUrlWithUtms !== 'function' || window.ymp_getUrlWithUtms.lm) return;
      var orig = window.ymp_getUrlWithUtms;
      window.ymp_getUrlWithUtms = function (u) { return comCupom(orig(u)); };
      window.ymp_getUrlWithUtms.lm = true;
    }
    customElements.define('lm-ir-checkout', class extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.lm-ir-checkout__btn');
        this.qtd = this.querySelector('.lm-ir-checkout__qtd');
        this.btn.addEventListener('click', () => this.ir());
        this.atualizar = this.atualizar.bind(this);
        document.addEventListener('cart:updated', this.atualizar);
        window.addEventListener('pageshow', () => this.classList.remove('is-indo'));
        this.atualizar();
      }
      disconnectedCallback() { document.removeEventListener('cart:updated', this.atualizar); }
      atualizar() {
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then((c) => {
          var tem = c.item_count > 0;
          this.hidden = !tem;
          var caixa = this.closest('.section-content-wrapper') || this.parentElement;
          if (caixa) { caixa.classList.toggle('lm-tem-carrinho', tem); caixa.classList.toggle('lm-contorno', tem && this.dataset.contorno !== 'false'); }
          if (this.dataset.contar !== 'false' && tem) { this.qtd.textContent = c.item_count; this.qtd.hidden = false; } else this.qtd.hidden = true;
        }).catch(function () {});
      }
      ir() {
        this.classList.add('is-indo');
        var cupom = (this.dataset.cupom || '').trim();
        window.lmCupomCheckout = cupom || null;
        embrulhar();
        window.lmAquecerYampi && window.lmAquecerYampi();
        if (typeof window.yampiClick === 'function') { window.yampiClick(); return; }
        location.href = '/checkout' + (cupom ? '?discount=' + encodeURIComponent(cupom) : '');
      }
    });
  })();
}
